import React, { useState } from "react";
import loginimg from "../Assets/Img/loginsideimg.png";
import { Link, useNavigate } from "react-router-dom";

function SignUp() {
  const navigate = useNavigate();
  const [userType, setUserType] = useState("");

  const handleRole = (type) => {
    setUserType(type);
    localStorage.setItem("userType", type); // Store in local storage if needed
    navigate("/signup-with-socials", { state: { userType: type } }); // Pass state to next page
  };
  return (
    <>
      <div className="container-signup p-0 mt-5 mb-5">
        <div className="card">
          <div className="row no-gutters">
            {/* Left Side (Image Section) */}
            <div className="col-12 col-md-6 col-sm-12 left">
              <img src={loginimg} alt="login-side-img" className="img" />
            </div>

            {/* Right Side (Login and Signup Buttons) */}
            <div className="col-12 col-md-6 col-sm-12 right">
              <h2>Welcome to InSocial Orbit</h2>
              <button
                type="button"
                className="btn btn-outline-success btn-lg mb-2"
                onClick={() => {
                  navigate("/signup-with-socials");
                  handleRole("brand");
                }} // Navigate to PhoneEmail page
              >
                Sign up as a Brand{" "}
              </button>
              {/* this changes do for navigate login page */}
              <button
                type="button"
                className="btn btn-outline-success btn-lg mb-2"
                onClick={() => {
                  navigate("/signup-with-socials");
                  handleRole("influencer");
                }} // Navigate to PhoneEmail page
              >
                Sign up as an Influencer{" "}
              </button>
              <div className="col-12 col-md-12 footer">
                <div className="sign-link mt-auto mb-1">
                  If you have an account? &nbsp;
                  {/* Add link to navigate back to the signup page */}
                  <Link to="/phone-email" className="btn-link">
                    Login &nbsp;
                  </Link>
                  here
                </div>
                <div
                  className="signup-instruction"
                  style={{
                    // marginTop: " 3%",
                    fontSize: "11px",
                  }}
                >
                  By continuing you agree to our terms and conditions
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default SignUp;
